import { Component, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { FcpLinkSizes } from 'fc-ui-components';

import { OrganizationType, SegmentService } from 'services';
import { AuthenticationModel } from 'src/app/authentication/authentication.model';

@Component({
    selector: 'fc-organization-type-selection',
    templateUrl: './organization-type-selection.component.html',
    styleUrls: ['./organization-type-selection.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: OrganizationTypeSelectionComponent
        }
    ],
    standalone: false
})
export class OrganizationTypeSelectionComponent implements ControlValueAccessor, OnInit, OnDestroy {
    organizationTypes = OrganizationType;
    type: OrganizationType = null;
    fcpLinkSizes = FcpLinkSizes;
    showOrgSwitcherLink$: Observable<boolean>;

    private _subscription = new Subscription();

    onChange = (type) => {};
    onTouched = () => {};

    constructor(
        private authenticationModel: AuthenticationModel,
        private segmentService: SegmentService,
        private authService: AuthService
    ) {}

    ngOnInit(): void {
        this.showOrgSwitcherLink$ = this.authService.user$
            .pipe(switchMap((user) => this.authenticationModel.getAppUserOrganizations(user.sub)))
            .pipe(map((userOrganizations) => userOrganizations?.length > 1));
    }

    setType(type: OrganizationType) {
        this.type = type;
        this.onChange(this.type);

        this.trackSignupStartRequest(type);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(obj: any): void {
        this.type = obj;
    }

    login() {
        this.segmentService.track('[Signup] LogIn selected');
        this._subscription.add(this.authService.loginWithRedirect().subscribe());
    }

    ngOnDestroy(): void {
        this._subscription.unsubscribe();
    }

    private trackSignupStartRequest(organziationType: string) {
        const eventPayload = {
            orgType: organziationType,
            signupType: 'normal'
        };

        this.segmentService.track('[Signup] Signup started', eventPayload);
    }
}
